import './news-feed.scss';

class NewsFeed {
    constructor(element, options) {
        const settings = {
            resizeTimeout: 150
        };

        this.settings = Object.assign({}, settings, options);
        this.$newsFeed = element;

        this.initialize();
    }

    initialize() {
        import ('../slider/slider').then(( { Slider }) => {
            new Slider(this.$newsFeed, {
                freeMode: true, 
                scrollbar: true, 
                speed: 500, 
                slidesPerView: 2, 
                slidesPerGroup: 2,
                initAttr: 'data-newsfeed',
                mousewheel: {
                    forceToAxis: true,
                    invert: true
                },
                breakpoints: {
                    767: {
                        slidesPerView: 1, 
                        slidesPerGroup: 1
                    }
                }
            });
        });
    }
}

export { NewsFeed };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const context = eventDetails.$context;

    if (context) {
        const $$newsFeed = context.querySelectorAll('[data-newsfeed="root"]');
        for (let i = 0; i < $$newsFeed.length; i++) {
            const $newsFeed = $$newsFeed[i];
            const newsFeedAPI = new NewsFeed($newsFeed);
            $newsFeed.newsFeedAPI = newsFeedAPI;
        }
    }
});
